"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCaret = void 0;
const react_1 = require("react");
const useCaret = (inputRef, value = '', formatter) => {
    const rawValue = (0, react_1.useRef)(value);
    const caretPositionRef = (0, react_1.useRef)(0);
    (0, react_1.useEffect)(() => {
        let newValue = value;
        const rawStr = rawValue.current;
        const caretPosition = caretPositionRef.current;
        const str = rawStr.substr(0, caretPosition);
        if (rawStr.length === value.length) {
            newValue = formatter(newValue);
        }
        const matched = newValue.indexOf(str);
        const index = matched === -1
            ? newValue.length - rawStr.length + caretPosition
            : newValue.indexOf(str) + caretPosition;
        if (inputRef.current &&
            index !== -1 &&
            inputRef.current.selectionStart !== undefined &&
            inputRef.current.selectionStart !== null &&
            document.activeElement === inputRef.current) {
            inputRef.current.selectionStart = inputRef.current.selectionEnd = index;
        }
    }, [formatter, value, inputRef]);
    const setCaretPosition = (0, react_1.useCallback)((currentValue) => {
        var _a;
        rawValue.current = currentValue;
        caretPositionRef.current = ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.selectionEnd) || 0;
    }, []);
    return {
        value,
        inputRef,
        setCaretPosition,
    };
};
exports.useCaret = useCaret;
